export default __webpack_public_path__ + "static/media/LPG Pipeline works.7a37c73f.jpg";